import { fixRound } from "./CommonUtil";

// 차트 값의 단위 표시를 위한 상수
const UNIT_SYMBOLS = ["", "M", "B", "T", "Q"] as const;
const FIRST_THRESHOLD = 1000000; // 첫 단계는 백만 단위
const SUBSEQUENT_THRESHOLD = 1000; // 이후 단계는 천 단위

/**
 * 숫자 값이 유효한지 검증하는 타입 가드
 */
const isValidNumber = (value: number): boolean =>
  value != null && !Number.isNaN(value);

const numberTickFormatHelper = (chartValues: number[]) => {
  const validValues = chartValues.filter(isValidNumber);

  // 유효한 값이 없거나 모두 0인 경우 조기 반환
  if (validValues.length === 0 || validValues.every((v: number) => v === 0)) {
    return { denominator: 1, symbol: "" };
  }

  let maxValue = Math.max(...validValues.map((v: number) => Math.abs(v)));

  let unitIndex = 0;
  while (
    maxValue >= FIRST_THRESHOLD ||
    (unitIndex > 0 && maxValue >= SUBSEQUENT_THRESHOLD)
  ) {
    const divisor = unitIndex === 0 ? FIRST_THRESHOLD : SUBSEQUENT_THRESHOLD;
    maxValue /= divisor;
    unitIndex += 1;
  }

  const denominator = unitIndex === 0 ? 1 : 1000 ** (unitIndex + 1);
  return {
    denominator,
    symbol: UNIT_SYMBOLS[unitIndex],
  };
};

export const numberTickFormatter =
  (chartValues: number[]) => (value: unknown) => {
    if (typeof value === "number") {
      const { denominator, symbol } = numberTickFormatHelper(chartValues);
      return `${fixRound(value / denominator, 1).toLocaleString()}${symbol}`;
    }
    return `${value}`;
  };
